// import { useWalletCheck } from "../hooks/useWalletCheck";
import { FiLock, FiAlertCircle } from "react-icons/fi";
import { useTranslation } from "../hooks/useTranslation";

export const ProtectedRouteByWallet = ({ children }) => {
    // const { walletAddress, isAllowed, isLoading, isConnected } = useWalletCheck();
    const { t } = useTranslation();

    const walletAddress = "0xaebc3a99724a59ec7be5ae1a17a14b712b89e057";

    // Loading state
    if (false) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center">
                    <div className="animate-spin rounded-full size-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-400">{t("common.loading")}</p>
                </div>
            </div>
        );
    }

    // Not connected state
    if (false) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center max-w-md p-8 bg-gray-800 rounded-lg shadow-xl">
                    <FiAlertCircle className="text-yellow-500 text-6xl mx-auto mb-4" />
                    <h2 className="text-2xl font-semibold text-white mb-2">
                        {t("validation.walletNotConnected")}
                    </h2>
                    <p className="text-gray-400 mb-4">
                        {t("validation.pleaseConnectYourWallet")}
                    </p>
                    <p className="text-xs text-gray-500">
                        {t("validation.clickConnectWallet")}
                    </p>
                </div>
            </div>
        );
    }

    // Access denied state
    if (false) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center max-w-md p-8 bg-gray-800 rounded-lg shadow-xl">
                    <FiLock className="text-red-500 text-6xl mx-auto mb-4" />
                    <h2 className="text-2xl font-semibold text-white mb-2">
                        {t("validation.accessDenied")}
                    </h2>
                    <p className="text-gray-400 mb-4">
                        {t("validation.walletNotAuthorized")}
                    </p>
                    <div className="bg-gray-900 rounded p-3 mb-4">
                        <p className="text-xs text-gray-500 mb-1">
                            {t("validation.connectedWallet")}
                        </p>
                        <p className="text-sm text-red-400 font-mono break-all">
                            {walletAddress}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    // Access granted - render children
    return <>{children}</>;
};
